import axios from 'axios';
import { HttpClient } from 'domain/ports';

class AxiosHttpClientAdapter implements HttpClient {
  async get(url: string): Promise<any> {
    const response = await axios.get(url);
    return response.data;
  }

  async post(url: string, body: any) {
    const response = await axios.post(url, body);
    return response.data;
  }

  async delete(url: string) {
    const response = await axios.delete(url);
    return response.data;
  }

  async put(url: string, body: any) {
    const response = await axios.put(url, body);
    return response.data;
  }
}

export const axiosHttpClientAdapter = new AxiosHttpClientAdapter();
